import React, { useEffect, useCallback, useState} from 'react';
import FrozenTrack from './freeze/FrozenTrack.js';
import {connect} from 'react-redux';
import '../../FreezeHistory.scss';

const FreezeHistory = ({track, _track=track}) => { 
    let {frozenTracks, frozenGroup} = track;
    let [hovered, setHovered] = useState(false);

    const unfreeze = useCallback(() => {
        _track.unfreeze(track.frozenGroup, track.frozenTracks);
    }, [_track, track]);

    return (
        <div className={hovered ? "freeze-history hovered" : "freeze-history"}>
          <div className="unfreeze-button"
               onClick={unfreeze}
               onMouseLeave={() => setHovered(false)}
               onMouseOver={() => setHovered(true)}>
            Unfreeze
          </div>
          {frozenTracks.map(
              frozenTrack => <FrozenTrack track={_track} frozenTracks={frozenTracks} frozenGroup={frozenGroup} frozenTrack={frozenTrack}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreezeHistory);
